import hljs from 'highlight.js'
import 'highlight.js/styles/googlecode.css'

let Highlight = {}
Highlight.install = function(Vue, options) {
    Vue.directive('highlight', function(el) {
        let blocks = el.querySelectorAll('pre code')
        blocks.forEach((block) => {
            hljs.highlightBlock(block)
        })
    })
}
export default Highlight


// WEBPACK FOOTER //
// ./src/util/mHighlight.js